export default "__VITE_ASSET__tG__aw2I__"